/* ========= Pauschale für Individualisierung – FIX & SILENT UI REFRESH ========= */
(function () {
  const FEE_PRODUCT_HANDLE = 'pauschale-fur-individualisierung';
  const FEE_PROP_KEY = '_auto_fee';
  const FEE_PROP_VAL = '1';

  // Werte, die eine Individualisierung anzeigen
  const TRIGGER_VALUES = new Set(['Eigener Wunschtext', 'Eigenes Logo', 'Eigener Upload']);

  // Produkte, bei denen die Pauschale gilt (Handles)
  const TRIGGER_PRODUCT_HANDLES = new Set([
    'feuerkids-leibchen-fuer-kinderfeuerwehren',
    'feuerkids-kennzeichnungskoller-gruppe-nach-fwdv-fuer-einsatzabteilung',
    'feuerkids-leibchen-fuer-jugendfeuerwehren-mit-taktischen-zeichen',
    'feuerkids-leibchen-nummernsatz',
    'feuerkids-kennzeichnungskoller-gruppe-nach-fwdv-fuer-jugendfeuerwehr',
    'feuerkids-flaschenhaube-atemschutzattrappe-asa'
  ]);

  let FEE_VARIANT_ID = '';
  const DEBUG = false;
  const log = (...a) => DEBUG && console.log('[FeeDebug]', ...a);

  // ---------- Helpers ----------
  async function ensureFeeVariantId() {
    if (FEE_VARIANT_ID) return FEE_VARIANT_ID;
    try {
      const res = await fetch(`/products/${FEE_PRODUCT_HANDLE}.js`);
      const prod = await res.json();
      FEE_VARIANT_ID = (prod.variants.find(v => v.available) || prod.variants[0])?.id;
      log('Fee Variant ID:', FEE_VARIANT_ID);
      return FEE_VARIANT_ID;
    } catch (err) {
      console.warn('⚠️ Fee variant fetch failed', err);
      return '';
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  // UI still aktualisieren (ohne Drawer zu öffnen)
  async function silentCartRefresh() {
    try {
      const html = await fetch('?section_id=helper-cart').then(r => r.text());
      const dom = new DOMParser().parseFromString(html, 'text/html');

      const cartFormInnerHTML = dom.getElementById('AjaxCartForm')?.innerHTML;
      const cartSubtotalInnerHTML = dom.getElementById('AjaxCartSubtotal')?.innerHTML;

      const cartItems = document.getElementById('AjaxCartForm');
      if (cartItems && cartFormInnerHTML) {
        cartItems.innerHTML = cartFormInnerHTML;
        // das Theme hängt hier eine Methode an das Element – wieder aktivieren:
        if (typeof cartItems.ajaxifyCartItems === 'function') {
          cartItems.ajaxifyCartItems();
        }
      }

      if (cartSubtotalInnerHTML && document.getElementById('AjaxCartSubtotal')) {
        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
      }

      // Header-Zähler aktualisieren
      document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
        const n = dom.querySelector('[data-cart-count]')?.textContent ?? '';
        elm.textContent = n;
      });
      document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
        const t = dom.querySelector('[data-cart-total]')?.textContent ?? '';
        elm.textContent = t;
      });
    } catch (e) {
      // als Fallback NICHT den Drawer öffnen:
      log('silentCartRefresh error', e);
    }
  }

  // gewünschte Anzahl Pauschalen in den Warenkorb bringen
  async function syncFeeQuantity(desiredQty) {
    const vid = await ensureFeeVariantId();
    if (!vid) return;

    const cart = await getCart();
    const existingFees = cart.items.filter(it => String(it.variant_id) === String(vid));
    const currentQty = existingFees.reduce((sum, it) => sum + it.quantity, 0);

    log('Fee qty -> desired:', desiredQty, 'current:', currentQty);
    if (currentQty === desiredQty) return;

    // Mehr Pauschalen nötig → korrektes { items: [...] } Format!
    if (desiredQty > currentQty) {
      const diff = desiredQty - currentQty;
      const items = Array(diff).fill({
        id: vid,
        quantity: 1,
        properties: { [FEE_PROP_KEY]: FEE_PROP_VAL }
      });

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      await silentCartRefresh();
      return;
    }

    // Zu viele Pauschalen → entfernen (stückweise)
    if (desiredQty < currentQty) {
      let toRemove = currentQty - desiredQty;
      for (const fee of existingFees) {
        if (toRemove <= 0) break;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: fee.key, quantity: 0 })
        });
        toRemove--;
      }
      await silentCartRefresh();
    }
  }

  // wie viele triggernde Produkte (mit Individualisierung) sind im Warenkorb?
  async function checkAndSyncFee() {
    const cart = await getCart();

    let triggerCount = 0;
    for (const it of cart.items) {
      // Nur die definierten Produkte
      if (!TRIGGER_PRODUCT_HANDLES.has(it.handle)) continue;

      const props = it.properties || {};
      const variantTitle = it.variant_title || '';

      const hasIndividualization =
        Object.values(props).some(v => TRIGGER_VALUES.has(String(v))) ||
        [...TRIGGER_VALUES].some(v => variantTitle.includes(v));

      if (hasIndividualization) triggerCount += 1; // 1× pro Produkt
    }

    log('triggerCount:', triggerCount);
    await syncFeeQuantity(triggerCount);
  }

  // ---------- Fetch-Interceptor (öffnet Drawer NICHT) ----------
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const [url] = args;
    const res = await origFetch(...args);

    try {
      if (typeof url === 'string') {
        if (url.includes('/cart/add.js')) {
          log('Intercept /cart/add.js');
          setTimeout(checkAndSyncFee, 500);
        } else if (url.includes('/cart/change') || url.includes('/cart/update')) {
          log('Intercept cart change/update');
          setTimeout(checkAndSyncFee, 300);
        }
      }
    } catch (err) {
      log('fetch intercept err', err);
    }
    return res;
  };

  // Beim Laden einmal prüfen
  document.addEventListener('DOMContentLoaded', () => {
    checkAndSyncFee();
  });
})();
